import AnalyzeService from '../../services/analyze';
import { processReportData } from '../../services/report/reportProcessor';

const analyzeService = new AnalyzeService();

// actions
const GET_REPORT_RAW_PAYLOAD = 'GET_REPORT_RAW_PAYLOAD';
const PREPARE_REPORT_PAYLOAD = 'PREPARE_REPORT_PAYLOAD';
const CLEAN_REPORT_DATA = 'CLEAN_REPORT_DATA';

function cleanReportData(dispatch) {
  dispatch({ type: CLEAN_REPORT_DATA });
}

function getReportPayload(preProcessedReportData, dispatch) {
  /**
   * Com o novo gerenciador do relatório, não realizamos mais uma requisição para obter os dados
   * de plotagem do gráfico, estes já são pré-processados no próprio gerenciador, e delegados
   * até este método. Com isto, para reutilizar a lógica pré-existente do reportProcessor,
   * apenas simulamos que os dados já foram carregados.
   */
  const resultPromise = new Promise((resolve) => resolve({
    data: preProcessedReportData,
    running: false,
    error: null,
  }));

  dispatch({ type: GET_REPORT_RAW_PAYLOAD, payload: resultPromise, meta: {}});
}

function prepareReportPayload(reportData, authToken, dispatch, reportColorConfig) {
  const resultPromise = processReportData(reportData, authToken, reportColorConfig);
  dispatch({ type: PREPARE_REPORT_PAYLOAD, payload: resultPromise, meta: {}});
}

export { GET_REPORT_RAW_PAYLOAD, PREPARE_REPORT_PAYLOAD, CLEAN_REPORT_DATA, getReportPayload, prepareReportPayload, cleanReportData };

